<template>
    <PurchasingDashboard></PurchasingDashboard>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const PurchasingDashboard = defineAsyncComponent(() =>
    import("../../components/Purchasing/Dashboard/Dashboard.vue")
);

export default {
    name: "Purchasing_Dashboard", //The name you are in should not equal the name of the component you are importing.
    components: { PurchasingDashboard, AuthLayout },
};
</script>
